import { getClaims } from "utility/getClaims";
import { hasPermission } from "./hasPermission";

const getCurrentUserModules = (): string[] => {
  const claims = getClaims();
  const modules = claims.map((x) => x?.split(":")[0]);
  return [...new Set<string>(modules)];
};

export const isMenuItemVisible = (menuItem: any) => {
  const { claimName, checkOnlyPermission } = menuItem;
  if (checkOnlyPermission) return hasPermission(menuItem.claimName);
 
  const currentUserModules = getCurrentUserModules();
  return currentUserModules.includes(claimName);
};
